































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Dialog } from "vant";
import axios from "axios";
import Word from "@/components/cards/word/singleWord.vue";
import EditWord from "@/components/modals/words/EditDictionaryWord.vue";
import MoveOrCopyWord from "@/components/modals/words/MoveWord.vue";

/* eslint-disable @typescript-eslint/class-name-casing */
/* eslint-disable @typescript-eslint/camelcase */
@Component({
  components: {
    EditWord,
    Word,
    MoveOrCopyWord,
  },
})
export default class SingleWordLevelCard extends Vue {
  @Prop() words!: any;
  type = "";
  Categories: any;
  currentRoute: any;
  show = false;
  wordIndex = -1;
  wordId = -1;
  synonyms: any = "hi, hi2";
  tempWords: any;
  dropdownOpen: boolean = false;
  @Emit("UpdateWords")
  UpdateWords() {
    this.show = false;
    return this.words;
  }
  @Emit("UpdateDayWord")
  UpdateDayWord() {
    return this.words;
  }

  ModalClose() {
    this.show = false;
  }
  wordStr = "";

  getSpilt(word: any) {
    return word.join(", ");
  }
  get currentRouteName() {
    return this.$route.name;
  }
  showEditModal(word: any, index: any) {
    const modal_id = "modal_" + index;
    this.$refs[modal_id][0].showPopup();
  }
  DeleteWord(index: any) {
    Dialog.confirm({
      title: "Delete",
      message: "Are you sure?",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    })
      .then(() => {
        this.$delete(this.words, index);
        if (this.$route.name == "main.word_of_the_day") {
          this.UpdateDayWord();
        } else this.UpdateWords();
      })
      .catch(() => {
        // on cancel
      });
  }
  SpiltString(word: any) {
    // alert("hi");
    word.synonyms = this.synonyms.split(",");
    word.isBookmarked = false;
  }
  DivId = -1;
  MouseHover(DivId: any) {
    this.DivId = DivId;
  }
  MouseLeave(DivId: any) {
    this.DivId = -1;
  }
  ShowEditInput(word: any, DivId: any) {
    this.DivId = -1;
    this.DivId = DivId;
    word.isBookmarked = true;
  }
  showPopup(word: any, index: any) {
    this.wordIndex = index;
    this.show = true;
  }

  showModal(index: any, CopyType: any) {
    this.type = CopyType;
    const modal_id = "modal_" + index;
    this.$refs[modal_id][0].showPopup();
  }

  async mounted() {
    const offset = { offset: 12 };
    // get all category list
    const response = await axios.post(
      "https://api.englishjanala.com:8443/v1/englishjanala/word/WordService/GetWordCategoryList",
      offset
    );
    const data = response.data.categories;
    this.Categories = data;
    console.log(data);
    console.log("wordss", response.data);
  }
  showModal1(index: any, CopyType: any, wordId: any) {
    this.type = CopyType;
    this.wordId = wordId;
    this.wordIndex = index;
    this.dropdownOpen = false;
    const modal_id = "modal_move_" + index;
    this.$refs[modal_id][0].showPopup();
  }
}
